import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export async function AddArtificialDelay<T>(
  promise: Promise<T>,
  duration: number,
): Promise<T> {
  const [res] = await Promise.allSettled([
    promise,
    new Promise((resolve) => setTimeout(resolve, duration)),
  ]);
  if (res.status === "rejected") {
    throw res.reason;
  }
  return res.value;
}
